export default "__VITE_ASSET__aa8f0622__"